import React from 'react'
import { ImageCode, Remember, Code } from './pages/Code'

//登录页面
const loginForm = {
  type: 'object',
  properties: {
    username: {
      type: 'string',
      title: '用户名'
    },
    password: {
      title: '密码',
      type: 'string',
      maxLength: 30,
      minLength: 6,
      fieldType: 'password'
    },
    remenber: {
      // title: '记住我',
      // type: 'boolean'
    },
    code: {
      title: '验证码',
      type: 'string',
    }
  },
  required: ['username', 'password'],
  form: ['username', {
    key: 'password', attrs: { type: 'password' },
    // validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
  },
    { key: 'code', component: ImageCode },
    { key: 'remenber', component: Remember },
    //  { key: 'code', component: ImageCode } 
  ]
}

const mobileloginForm = {
  type: 'object',
  properties: {
    username: {
      type: 'string',
      title: '用户名'
    },
    password: {
      title: '密码',
      type: 'string',
      minLength: 6,
      maxLength: 30,
      fieldType: 'password'
    },
    remenber: {
      // title: '记住我',
      // type: 'boolean'
    },
    code: {
      title: '验证码',
      type: 'string',
    },
    mobileCode: {
      title: '验证码',
      type: 'string',
    }
  },
  required: ['username', 'password'],
  form: ['username', {
    key: 'password', attrs: { type: 'password' },
    // validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
  },
    { key: 'mobileCode', component: Code },
    { key: 'code', component: ImageCode },
    { key: 'remenber', component: Remember },
  ]
}
//注册页
const regForm = {
  type: 'object',
  properties: {
    com: {
      type: 'string',
      title: '公司'
    },
    username: {
      type: 'string',
      title: '用户名'
    },
    realname: {
      type: 'string',
      title: '姓名'
    },
    mobileNumber: {
      type: 'string',
      title: '手机号'
    },
    // code: {
    //   title: '获取验证码',
    //   type: 'string',
    // },
    password: {
      type: 'string',
      title: '密码',
      maxLength: 30,
      minLength: 6
    },
    email: {
      title: '邮箱',
      type: 'string'
    }
  },
  form: [
    'username',
    {
      key: 'password', attrs: { type: 'password' },
      validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
    }, 'realname',
    { key: 'mobileNumber', validate: value => ((/^1[3456789]\d{9}$/).test(value) ? null : '手机号必须为11位数字') },
    // { key: 'code', component: Code },  
    'com', 'email'],
  required: ['username', 'password', 'realname', 'mobileNumber', 'com', 'email']
}

const pwdPage = {
  type: 'object',
  properties: {
    password: {
      type: 'string',
      title: '密码',
      maxLength: 30,
      minLength: 6,
      fieldType: 'password'
    },
    password2: {
      type: 'string',
      title: '确认密码',
      maxLength: 30,
      minLength: 6,
      fieldType: 'password'
    }
  },
  form: [{
    key: 'password',
    attrs: { type: 'password' },
    validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
  }, {
    key: 'password2',
    attrs: { type: 'password' },
    // validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合'),
    validate: (value, { password }) => value == password ? ((/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')) : '两次输入密码不一致',
  }]
}

//手机号重置密码
const resetPhoneForm = {
  type: 'object',
  properties: {
    phone: {
      type: 'string',
      title: '手机号'
    },
    code: {
      type: 'string',
      title: '验证码'
    }
  },
  form: ['phone', { key: 'code', component: ImageCode }]
}
//邮箱重置密码
const resetEmailForm = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      title: '邮箱'
    },
    code: {
      type: 'string',
      title: '验证码'
    }
  },
  form: ['email', 'code']
}

export {
  loginForm,
  regForm,
  pwdPage,
  resetPhoneForm,
  resetEmailForm,
  mobileloginForm
}
